import "babel-polyfill";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'bulmajs/dist/bulmajs.js';

const $ = window.jQuery || window.$;

if (!$) {
    throw new Error('Global jQuery not found. Please load ~/javascript/jquery.js before app.bundle.js.');
}

if (!import.meta.env.PROD) {
  console.log('Looks like we are in development mode!');
}

function initSwiperSafely(containerEl, options) {
    if (!(containerEl instanceof Element)) {
        return null;
    }

    try {
        return new Swiper(containerEl, options);
    } catch (err) {
        console.warn('Skip Swiper init due to invalid markup or missing sub-elements.', containerEl, err);
        return null;
    }
}


$(window).on('scroll touchmove', function () {
    $('.main-header').toggleClass('tiny-head', $(document).scrollTop() > 0);
}).scroll();

document.querySelectorAll('.banner-wrapper').forEach((bannerEl) => {
    const bannerWrapperEl = bannerEl.querySelector('.swiper-wrapper');
    if (!bannerWrapperEl) {
        return;
    }

    const bannerSlides = bannerWrapperEl.querySelectorAll('.swiper-slide');
    if (bannerSlides.length <= 1) {
        return;
    }

    const bannerOptions = {
        autoplay: true,
        loop: true,
    };

    const bannerPaginationEl =
        bannerEl.querySelector('.banner-swiper-pagination') ||
        bannerEl.parentElement?.querySelector('.banner-swiper-pagination') ||
        null;

    if (bannerPaginationEl) {
        bannerOptions.pagination = {
            el: bannerPaginationEl,
            clickable: true,
        };
    }

    initSwiperSafely(bannerEl, bannerOptions);
});

document.querySelectorAll('.service-wrapper').forEach((serviceEl) => {
    const serviceWrapperEl = serviceEl.querySelector('.swiper-wrapper');
    if (!serviceWrapperEl) {
        return;
    }

    const serviceSlides = serviceWrapperEl.querySelectorAll('.swiper-slide');
    if (serviceSlides.length <= 1) {
        return;
    }

    const serviceOptions = {
        slidesPerView: 4,
        breakpoints: {
            480: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 2
            }
        },
    };

    const servicePaginationEl =
        serviceEl.querySelector('.service-swiper-pagination') ||
        serviceEl.parentElement?.querySelector('.service-swiper-pagination') ||
        null;
    const serviceNextEl =
        serviceEl.querySelector('.service-btn-next') ||
        serviceEl.parentElement?.querySelector('.service-btn-next') ||
        null;
    const servicePrevEl =
        serviceEl.querySelector('.service-btn-prev') ||
        serviceEl.parentElement?.querySelector('.service-btn-prev') ||
        null;

    if (servicePaginationEl) {
        serviceOptions.pagination = {
            el: servicePaginationEl,
            clickable: true,
        };
    }

    if (serviceNextEl && servicePrevEl) {
        serviceOptions.navigation = {
            nextEl: serviceNextEl,
            prevEl: servicePrevEl,
        };
    }

    initSwiperSafely(serviceEl, serviceOptions);
});

$('#menu-btn').click(function() {
  $('body').toggleClass('is-opened');
});

$('#closeMenu').click(function() {
  $('body').removeClass('is-opened');
});

$('.sub-menu-btn').click(function() {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
    } else {
        $('.sub-menu-btn').removeClass('active');
        $(this).addClass('active');
    }
});

$('[data-toggle-close]').click(function() {
    let parent = $(this).data('parent');
    let className = $(this).data('toggle-close');
    $(this).parents(parent).find('[data-toggle=' + className + ']').removeClass(className);
});
$('[data-toggle]' ).click(function() {
    let className = $(this).data('toggle')
    $(this).toggleClass(className);
});
$('.modal-btn').click(function() {
    let el = $(this).data('modal-el');
    $(el).addClass('is-active');
});
$('.modal-close-btn, .modal-close, .modal-background').click(function() {
    $(this).parents('.modal').removeClass('is-active');
});
$(window).scroll(function () {
    if (document.getElementsByClassName('scroll-btn-container').length) {
        onScrollHandle();
    }
});

$('.scroll-btn .scroll-btn-a').click(function (e) {
    var headerHeight = $('.main-header').height();
    e.preventDefault();
    var curLink = $(this);
    var scrollPoint = $(curLink.data('href')).offset().top - headerHeight;
    $('body,html').animate({
        scrollTop: scrollPoint
    }, 500);
})

function onScrollHandle() {
    var currentScrollPos = $(document).scrollTop();
    var headerHeight = $('.main-header').height();
    var $scrollBtn = $('.scroll-btn');
    $scrollBtn.toggleClass('is-fixed', currentScrollPos > $('.scroll-btn-container').offset().top - headerHeight);

    var offset = $scrollBtn.data('offset') ? $scrollBtn.data('offset') : 0;
    var $link = $('.scroll-btn .select-link-btn');

    $link.each(function (index, value) {
        var curLink = $(this);
        var refElem = $(curLink.data('href'));

        if ($link.eq(index + 1).length) {
            var refNextElem = $($link.eq(index + 1).data('href'));

            if (Object.keys(refElem).length && Object.keys(refNextElem).length && currentScrollPos >= refElem.position().top + offset && currentScrollPos < refNextElem.position().top + offset) {
                $link.removeClass("active");
                curLink.addClass("active");
                let btnId = curLink.data('btn-id');
                if (btnId) {
                    $(btnId).addClass("active");
                }
            } else {
                curLink.removeClass("active");
            }
        } else {
            if (Object.keys(refElem).length && currentScrollPos >= refElem.position().top) {
                $link.removeClass("active");
                curLink.addClass("active");
            } else {
                curLink.removeClass("active");
            }
        }
    });
}

if ($.fn.scrollbar) {
    $('.scrollbar-inner').scrollbar();
}



$('.category-current').click(function() {
    var index = $('.category-current').index(this);
    var $this = $(this);
    if ($this.hasClass('active')) {
        $this.removeClass('active');
        $('.category-nav').eq(index).removeClass('is-opened');
        $this.html($this.data('name'));
    } else {
        $('.category-nav').removeClass('is-opened');
        $('.category-current').removeClass('active');
        $this.addClass('active');
        $('.category-nav').eq(index).addClass('is-opened');
    }
});

$('.category-btn').click(function() {
    var $this = $(this);
    var $parentRoot = $(this).parent().parent();
    var parentIndex = $('.category-list').index($parentRoot);
    var $current = $('.category-current').eq(parentIndex);

    $parentRoot.removeClass('is-opened');
    $current.removeClass('active')
    if ($this.hasClass('active')) {

        $this.removeClass('active');
        $current.html($current.data('name')).removeClass('has-value');
    } else {
        $this.parent().find('.category-btn').removeClass('active');
        $this.addClass('active');
        $current.html($this.html()).addClass('has-value');
    }
});

$('.category-more').click(function() {
    $(this).prev().toggleClass('is-opened');
})
